import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'
import {
  colorBlackAlpha50,
  elevatedSurfaceBoxShadow,
} from '../../../shared/style-settings'

export const useCheckoutDescriptionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3, 3, 14),
      textAlign: 'left',
    },
    description: {
      display: 'flex',
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    paper: {
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 8,
      boxShadow: elevatedSurfaceBoxShadow,
      '&:before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 4,
        background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
      },
    },
    textArea: {
      textAlign: 'left',
      [theme.breakpoints.up('md')]: {
        paddingRight: '15px',
        flexGrow: 1,
      },
    },
    '@keyframes imageLoadingAnimation': {
      '0%': {
        backgroundPosition: '-250px 0',
      },
      '100%': {
        backgroundPosition: '250px 0',
      },
    },



    imageAreaNonAnimation: {
      animationName: 'none',
    },
    imgBgWrapper: {},

    descriptionText: {
      fontSize: 14,
      lineHeight: 1.7,
      color: colorBlackAlpha50,
    },
    sectionLabel: {
      display: 'block',
      marginBottom: theme.spacing(1),
      color: colorBlackAlpha50,
      fontWeight: 600,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
    },
    textWrapper: {
      marginBottom: 20,
    },
  })
)
